export const disabledDarkColor = '#04606E';
export const disabledLightColor = '#F0F4F5';
